import { render, staticRenderFns } from "./Zcwj.vue?vue&type=template&id=37f7dafc&scoped=true&"
import script from "./Zcwj.vue?vue&type=script&lang=js&"
export * from "./Zcwj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f7dafc",
  null
  
)

export default component.exports